var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio",attrs:{"id":"home"}},[_c('Section1'),_c('Video'),_c('Method'),_c('Section2'),_c('Testimonials'),_c('AboutMe'),_c('Section7'),_c('Section4'),_c('WorkSteps'),_c('Section8')],1)}
var staticRenderFns = []

export { render, staticRenderFns }